import styled from 'styled-components';

export const EventSectionListStyle = styled.div`
  .help-text {
    margin: 10px 0;
    color: #6200ea;
    font-size: 11px;
    font-weight: 600;
  }

  .amondz-form-sub-content {
    color: #6200ea;
    line-height: 20px;
  }
`;

export const SectionNavigationTabStyle = styled.span`
  .amondz-img {
    height: 11px;
    margin-right: 2px;
  }
`;
